import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirplayvideoComponent } from './simple-icons-airplayvideo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirplayvideoComponent ],
    exports:      [ SimpleIconsAirplayvideoComponent ],
    bootstrap:    []
})
export class SimpleIconsAirplayvideoModule {}
